<template>
    <b-modal
        :visible="visible"
        centered
        hide-footer
        size="xl"
        title="Sửa đề thi"
        @hide="onClose"
    >
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Mã đề <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Mã đề"
                                rules="required|max:100"
                            >
                                <input
                                    v-model="form.code"
                                    class="form-control"
                                    disabled
                                    placeholder="Nhập mã đề"
                                    type="text"
                                />
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("code")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Tên đề <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Tên đề"
                                rules="required|max:100"
                            >
                                <input
                                    v-model="form.name"
                                    class="form-control"
                                    placeholder="Nhập tên đề"
                                    type="text"
                                />
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("name")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Loại thi <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Loại thi"
                                rules="required"
                            >
                                <select
                                    v-model="form.exam_type"
                                    class="form-control"
                                    :disabled="isEntranceExam"
                                >
                                    <option value="">Chọn loại thi</option>
                                    <option
                                        v-for="type in examTypesForEdit"
                                        :key="type.value"
                                        :value="type.value"
                                    >
                                        {{ type.label }}
                                    </option>
                                </select>
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("exam_type")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Trung tâm <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Trung tâm"
                                rules="required"
                            >
                                <el-select
                                    v-model="form.center_ids"
                                    class="w-100"
                                    clearable
                                    collapse-tags
                                    multiple
                                    placeholder="Chọn trung tâm"
                                    @change="onCenterChange"
                                >
                                    <el-option
                                        v-for="item in centers"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("center_ids")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div v-if="form.center_ids.length > 0 && !isEntranceExam" class="col-md-6">
                        <div class="form-group">
                            <label>Khoá học <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Khoá học"
                                rules="required"
                            >
                                <el-select
                                    v-model="form.course_ids"
                                    class="w-100"
                                    clearable
                                    collapse-tags
                                    multiple
                                    placeholder="Chọn khoá học"
                                >
                                    <el-option
                                        v-for="item in courses"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("course_ids")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>                   
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                            >Thời gian bắt đầu áp dụng
                                <span class="text-danger">*</span></label
                            >
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Thời gian bắt đầu áp dụng"
                                rules="required"
                            >
                                <date-picker
                                    v-model="form.apply_from"
                                    class="w-100"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    placeholder="Chọn thời gian"
                                    type="datetime"
                                    value-type="format"
                                />
                                <span class="text-danger small">{{
                                        errors[0] || getApiError("apply_from")
                                    }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Hình thức test <span class="text-danger">*</span></label>
                      <ValidationProvider
                          v-slot="{ errors }"
                          name="Hình thức test"
                          rules="required"
                      >
                        <el-select
                            v-model="form.exam_mode"
                            class="w-100"
                            collapse-tags
                            placeholder="Chọn hình thức test"
                            :disabled="isEntranceExam"
                        >
                          <el-option
                              v-for="item in examModes"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger small">{{ errors[0] || getApiError('exam_mode') }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-if="isEntranceExam" class="col-md-6">
                    <div class="form-group">
                      <label>Thứ tự mã đề <span class="text-danger">*</span></label>
                      <ValidationProvider
                          v-slot="{ errors }"
                          name="Thứ tự mã đề"
                          rules="required"
                      >
                        <el-select
                            v-model="form.order"
                            class="w-100"
                            placeholder="Chọn thứ tự mã đề"
                        >
                          <el-option
                              v-for="item in orderOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger small">{{ errors[0] || getApiError('order') }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <button class="btn btn-light mr-2" type="button" @click="onClose">
                        Huỷ bỏ
                    </button>
                    <button
                        :disabled="isSubmitting"
                        class="btn btn-primary"
                        type="submit"
                    >
            <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm mr-1"
            ></span>
                        Xác nhận
                    </button>
                </div>
            </form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {UPDATE_MARKING_EXAM} from "../core/services/store/marking/marking.module";

const EXAM_TYPE_ENTRANCE_EXAM = 20;
const EXAM_MODE_ONLINE = 2;

export default {
    name: "MarkingExamEditModal",
    components: {ValidationObserver, ValidationProvider, DatePicker},
    props: {
        visible: Boolean,
        centers: Array,
        courses: Array,
        examTypes: Array,
        selectedCenterId: String,
        loadingCourses: Boolean,
        exam: Object,
        orderOptions: Array,
    },
    data() {
        return {
            form: {
                id: "",
                code: "",
                name: "",
                center_ids: [],
                course_ids: [],
                exam_type: "",
                order: "",
                apply_from: "",
                exam_mode: null
            },
            isSubmitting: false,
            apiErrors: {},
            examModes: [{ name: 'Online' , value: 2},{ name: 'Offline' , value: 1}]
        };
    },
    computed: {
        isEntranceExam() {
            return (
                this.exam &&
                this.exam.exam_type !== undefined &&
                Number(this.exam.exam_type) === EXAM_TYPE_ENTRANCE_EXAM
            );
        },
        examTypesForEdit() {
            const types = this.examTypes || [];
            if (
                this.exam &&
                this.exam.exam_type !== undefined &&
                Number(this.exam.exam_type) !== EXAM_TYPE_ENTRANCE_EXAM
            ) {
                return types.filter(
                    (t) => Number(t.value) !== EXAM_TYPE_ENTRANCE_EXAM
                );
            }
            return types;
        },
    },
    watch: {
        exam: {
            handler(val) {
                if (val) {
                    const entrance = Number(val.exam_type) === EXAM_TYPE_ENTRANCE_EXAM;
                    this.form = {
                        id: val.id || "",
                        code: val.code || "",
                        name: val.name || "",
                        center_ids: val.centers.map((center) => center.id) || [],
                        course_ids: entrance
                            ? []
                            : val.courses.map((course) => course.id) || [],
                        exam_type: val.exam_type !== undefined ? String(val.exam_type) : "",
                        order: val.order != null && val.order !== "" ? Number(val.order) : "",
                        apply_from: val.apply_from ? val.apply_from : "",
                        exam_mode: entrance
                            ? EXAM_MODE_ONLINE
                            : (val.exam_mode != null && val.exam_mode !== ""
                                ? Number(val.exam_mode)
                                : null),
                    };
                    this.isSubmitting = false;
                }
            },
            immediate: true,
        },
        selectedCenterId(val) {
            this.form.center_ids = val;
        },
        visible(val) {
            if (!val) return;
            if (this.exam) {
                if (this.exam.center_ids) {
                    this.$emit("center-change", String(this.exam.center_ids));
                }

                const entrance =
                    this.exam.exam_type !== undefined &&
                    Number(this.exam.exam_type) === EXAM_TYPE_ENTRANCE_EXAM;

                this.form = {
                    id: this.exam.id || "",
                    code: this.exam.code || "",
                    name: this.exam.name || "",
                    center_ids: this.exam.centers.map((center) => center.id) || [],
                    course_ids: entrance
                        ? []
                        : this.exam.courses.map((course) => course.id) || [],
                    exam_type:
                        this.exam.exam_type !== undefined
                            ? String(this.exam.exam_type)
                            : "",
                    order:
                        this.exam.order != null && this.exam.order !== ""
                            ? Number(this.exam.order)
                            : "",
                    apply_from: this.exam.apply_from
                        ? this.formatDate(this.exam.apply_from)
                        : "",
                    exam_mode: entrance
                        ? EXAM_MODE_ONLINE
                        : (this.exam.exam_mode != null && this.exam.exam_mode !== ""
                            ? Number(this.exam.exam_mode)
                            : null),
                };
            }
        },
        courses(newCourses) {
            if (this.form.course_id && newCourses && newCourses.length) {
                const found = newCourses.find(
                    (c) => String(c.id) === String(this.form.course_id)
                );
                if (!found) {
                    this.form.course_id = "";
                } else {
                    this.form.course_id = String(this.form.course_id);
                }
            }
        },
    },
    methods: {
        getApiError(field) {
            return this.apiErrors?.[field]?.[0] || "";
        },
        onClose() {
            this.$emit("close");
        },

        async onSubmit() {
            this.isSubmitting = true;
            this.apiErrors = {};
            const payload = {
                ...this.form,
                course_ids: this.isEntranceExam ? [] : this.form.course_ids,
            };
            if (this.isEntranceExam) {
                payload.exam_mode = EXAM_MODE_ONLINE;
            } else {
                delete payload.order;
            }
            await this.$store
                .dispatch(UPDATE_MARKING_EXAM, payload)
                .then(() => {
                    this.$emit("updated");
                    this.onClose();
                })
                .catch((err) => {
                    this.apiErrors = err.response.data.errors;
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        onCenterChange() {
            if (!this.isEntranceExam) {
                this.form.course_ids = [];
            }
            this.$emit("center-change", this.form.center_ids);
        },
        formatDate(date) {
            if (!date) return "";
            const d = new Date(date);
            const pad = (n) => (n < 10 ? "0" + n : n);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
                d.getDate()
            )} ${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
        },
    },
};
</script>
